import AuthorizationWrapper, {
  authFnAllowAdminImplementationManagerOrSASupervisor,
} from '@product-framework/components/AuthorizationWrapper';
import { getRoutes } from '@ui-framework/index';
import NotificationSettingsPage from './pages/settings';
import NotificationInboxPage from './pages/inbox';
import NotificationPreferencesPage from './pages/preferences';
import NotificationInboxStore from './store/inbox';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

const Pages = ProtectedRoute => ({
  NotificationSettingsPage: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowAdminImplementationManagerOrSASupervisor],
      }}
      Component={NotificationSettingsPage}
    />
  ),
  NotificationInboxPage: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={NotificationInboxPage}
    />
  ),
  NotificationPreferencesPage: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={NotificationPreferencesPage}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = () => [{ notificationInboxStore: new NotificationInboxStore() }];

export {
  NotificationSettingsPage,
  NotificationInboxPage,
  NotificationPreferencesPage,
  routes,
  stores,
};
